import { RuleCard } from './RuleCard';
import type { OrderFlow } from 'domain-model/types/oms';
import { Card, CardHeader, CardBody, Badge } from 'reactstrap';

interface StateSectionProps {
  orderFlow: OrderFlow;
  selectedRules: Set<string>;
  onRuleToggle: (ruleName: string, selected: boolean) => void;
  onStateToggle: (state: string, selected: boolean) => void;
}

const stateLabels = {
  received: 'Granskas',
  waitingForRestock: 'Väntar på påfyllning',
  approvedByDropshipSupplier: 'Godkänd av dropship-leverantör',
  enRoute: 'På väg',
  delivered: 'Levererad',
};

export function StateSection({
  orderFlow,
  selectedRules,
  onRuleToggle,
  onStateToggle,
}: StateSectionProps) {
  const allRulesSelected = orderFlow.rules.every(rule =>
    selectedRules.has(rule.id),
  );
  const someRulesSelected = orderFlow.rules.some(rule =>
    selectedRules.has(rule.id),
  );
  const selectedCount = orderFlow.rules.filter(rule =>
    selectedRules.has(rule.id),
  ).length;

  const handleStateToggle = (checked: boolean) => {
    onStateToggle(orderFlow.state, checked);
  };

  return (
    <Card className="mb-4">
      <CardHeader>
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <div className="form-check me-3">
              <input
                className="form-check-input"
                type="checkbox"
                checked={allRulesSelected}
                ref={el => {
                  if (el)
                    el.indeterminate = someRulesSelected && !allRulesSelected;
                }}
                onChange={e => handleStateToggle(e.target.checked)}
                id={`state-${orderFlow.state}`}
              />
            </div>
            <div>
              <h5 className="card-title mb-1">
                När:{' '}
                {stateLabels[orderFlow.state as keyof typeof stateLabels] ||
                  orderFlow.state}
              </h5>
              <p className="text-muted small mb-0">
                Orderstatus:{' '}
                <code className="bg-light px-1 rounded">{orderFlow.state}</code>
              </p>
            </div>
          </div>
          <div>
            <Badge
              color={
                selectedCount === orderFlow.rules.length
                  ? 'primary'
                  : 'secondary'
              }
            >
              {selectedCount} av {orderFlow.rules.length} valda
            </Badge>
          </div>
        </div>
      </CardHeader>
      <CardBody>
        {orderFlow.rules.map(rule => (
          <RuleCard
            key={rule.id}
            rule={rule}
            isSelected={selectedRules.has(rule.id)}
            onToggle={selected => onRuleToggle(rule.id, selected)}
          />
        ))}
      </CardBody>
    </Card>
  );
}
